// import '@babel/polyfill';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuetify from 'vuetify/lib';
// import 'vuetify/src/stylus/app.styl';
//import VeeValidate from 'vee-validate';
import 'vuetify/dist/vuetify.min.css';
import resize from 'vue-resize-directive';
import 'vue-croppa/dist/vue-croppa.css';
import Croppa from 'vue-croppa';
import Pusher from 'pusher-js';

// import { StripePlugin } from '@vue-stripe/vue-stripe';
// import { StripeElementsPlugin } from '@vue-stripe/vue-stripe';

// const options = {
//   pk: "pk_test_V8cgd71pGDAKe2q2BnHJZXsH00jdNxmY34",
//  // stripeAccount: "Taybull",
//  // apiVersion: "v3",
//   locale: "en_GB",
//   // See https://stripe.com/docs/js/elements_object/create#stripe_elements-options
//   elementsOptions: {
//     fonts: [],
//     locale: 'auto',
//   },
// };

// Vue.use(StripePlugin, options);
// Vue.use(StripeElementsPlugin, options);


// import '@/components/assets/background/data/web-gradients.css'
//import fullscreen from 'vue-fullscreen';

// import VueHtml2Canvas from 'vue-html2canvas';

Vue.config.performance = true;


// import ECharts from 'vue-echarts';
// import VueParticles from 'vue-particles'
//import ECharts from 'vue-echarts/components/ECharts.vue';
import ApiService from "@/services/api.service";
import JwtService from "@/services/jwt.service";

import sassStyles from './assets/sass/main.scss';



ApiService.init();

// import { CHECK_AUTH } from "./store/actions.type";
// window.JQuery = require('jquery')
// import  Tabletop from "tabletop";
//import XLSX from 'xlsx';
import VueProgressBar from 'vue-progressbar';

import Sortable from 'vue-sortable';
Vue.use(Sortable);


import vueDebounce from 'vue-debounce';
Vue.use(vueDebounce);
// Vue.use(VueHtml2Canvas);



Vue.use(VueProgressBar, {
  color: 'blue',
  failedColor: 'red',
  height: '20px'
});

// Vue.use(fullscreen);

// window.Tabletop = Tabletop;
// window.xlsx = XLSX;
//window.XLSX = XLSX;
// tabletop.init();

Vue.config.productionTip = true;

Vue.use(Vuetify)

Vue.use(Croppa);
// Vue.use(VueApexCharts)
// Vue.use(VueParticles)
// Vue.use(VeeValidate)

import { Validator, install as VeeValidate } from 'vee-validate/dist/vee-validate.minimal.esm.js';
import { required, min, max, email } from 'vee-validate/dist/rules.esm.js';
import veeEn from 'vee-validate/dist/locale/en';

// Add the rules you need.
Validator.extend('required', required);
Validator.extend('min', min);
Validator.extend('max', max);
Validator.extend('email', email);
// Merge the messages.
Validator.localize('en', veeEn);

// Validator.extend('required', {
//   getMessage: field => 'The ' + field + ' value is not truthy.',
//   validate: value => !! value
// });



// install the plugin
Vue.use(VeeValidate);


Pusher.logToConsole = true;
Vue.prototype.$pusher = new Pusher('7b4bdc4a6005360b8a35', { cluster: 'eu' });
// console.log('env', JSON.stringify(process.env));
// Ensure we checked auth before each page load.
router.beforeEach((to, from, next) => {
  Promise.all([store.dispatch('users/aCheckAuth')]).then(function() {
    if(to.matched.some(record => record.meta.requiresAuth)) {
      let user = JwtService.getUser();

      if (JwtService.getToken() == null || user == null) {
             next({
                 name: 'signin',
                 params: { nextUrl: to.fullPath }
             });
      } else if(user && typeof user.project_id != "undefined" && user.project_id != null) {
        // console.log("to", to);
        // console.log("user", user);
        if(to.name != "dashboard") {
          next({
              name: 'dashboard',
              params: { projectId: user.project_id }
          })
        } else {
          next();
        }

      } else {
        next();
      }
    } else {
      next();
    }

  });

  // Promise.all([store.dispatch('users/aCheckAuth')]).then(next)
});



// Vue.component('apexchart', VueApexCharts);
// Vue.component('echart', ECharts);

Vue.directive('resize', resize);

new Vue({
  router: router,
  store: store,
  render: h => h(App)
}).$mount('#app')
